import React from 'react';
import {
  ProductHeaderBannerScrollButton,
  ProductHeaderBannerScrollContent,
  ProductHeaderBannerScrollWrapper,
  ProductHeaderBannerScrollInner,
} from './ProductHeaderBannerScroll.styles';
import { Button } from '@uk-source-web/button';
import { ProductHeadrBannerScrollProps } from './ProductHeadrBannerScroll.types';
import { Heading } from '@uk-source-web/heading';
import { getImage, getSrc } from 'gatsby-plugin-image';
import Image from '@uk-source-web/image';

const ProductHeaderBannerScroll = ({ productName, primaryButton, productImage }: ProductHeadrBannerScrollProps) => {
  const imageTitleSrc = getSrc(productImage?.imageTitle);
  const imageTitlePlaceholder = getImage(productImage?.imageTitle)?.placeholder?.fallback;
  const mobileBackgroundImageSrc = getSrc(productImage?.mobileBackgroundImage);
  const mobileBackgroundImagePlaceholder = getImage(productImage?.mobileBackgroundImage)?.placeholder?.fallback;
  const OPCO = process.env.GATSBY_OPCO;

  const defaultTypename = [
    'ContentfulSectionCardDisplay',
    'ContentfulSectionSwPricingContent',
    'ContentfulSectionSwTariffCards',
    'ContentfulSectionSwFeaturesOverview',
    'ContentfulSectionSwSmallPricingCard',
  ];
  const handleClick = (typenames: string[]) => {
    typenames.forEach(typename => {
      window.dispatchEvent(new CustomEvent('switch-tab', { detail: { typename } }));
      const el = document.getElementById(`section-${typename}`);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  };
  return (
    <ProductHeaderBannerScrollWrapper>
      <ProductHeaderBannerScrollInner OPCO={OPCO}>
        <ProductHeaderBannerScrollContent>
          <Image
            alt=""
            sm={{
              src: mobileBackgroundImageSrc || mobileBackgroundImagePlaceholder || '',
              width: '40px',
              height: '40px',
            }}
            md={{
              src: imageTitleSrc || imageTitlePlaceholder || '',
              width: '56px',
              height: '56px',
            }}
            lg={{
              src: imageTitleSrc || imageTitlePlaceholder || '',
              width: '60px',
              height: '60px',
            }}
          />
          <Heading level={4} text={productName} />
        </ProductHeaderBannerScrollContent>
        <ProductHeaderBannerScrollButton OPCO={OPCO}>
          {primaryButton && <Button text={primaryButton.label} onClick={() => handleClick(defaultTypename)} />}
        </ProductHeaderBannerScrollButton>
      </ProductHeaderBannerScrollInner>
    </ProductHeaderBannerScrollWrapper>
  );
};

export default ProductHeaderBannerScroll;
